import { render, staticRenderFns } from "./LoaderLayout.vue?vue&type=template&id=bebae928&"
import script from "./LoaderLayout.vue?vue&type=script&lang=js&"
export * from "./LoaderLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports